<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[22px] leading-[28px] text-gray-800 font-primary font-semibold text-center px-6 flex flex-col items-center"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mb-5 mx-auto">
        {{ question }}
      </div>

      <div class="mt-auto w-full">
        <div class="flex flex-col gap-y-[9px] mb-[30px]">
          <SelectOption v-model="answers" icon="🎵" value="Music">
            Music
          </SelectOption>
          <SelectOption v-model="answers" icon="📷" value="Photography">
            Photography
          </SelectOption>
          <SelectOption v-model="answers" icon="✍️" value="Writing">
            Writing
          </SelectOption>
          <SelectOption v-model="answers" icon="🖼️" value="Visual art / design">
            Visual art / design
          </SelectOption>
          <SelectOption v-model="answers" icon="🎬" value="Film / video">
            Film / video
          </SelectOption>
          <SelectOption v-model="answers" icon="🖥️" value="Other">
            Other
          </SelectOption>
        </div>

        <UiButton
          class="w-full"
          :disabled="!answers.length"
          primary
          large
          @click="handleClick"
        >
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { computed } from 'vue'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question =
  'What type of creative work do you or your organization produce?'

const answers = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Three] || []) as string[]
  },
  set(value: string[]) {
    onboardingStore.state[OnboardingStep.Three] = value
  },
})

const handleClick = () => {
  completeStep({
    step: 3,
    question,
    answers: answers.value,
  })

  onboardingStore.goToNextStep({
    question,
    answers: answers.value,
  })
}
</script>
